import { useMutation } from "@tanstack/react-query";

import { jsonRequest } from "@/lib/network/json-request";

interface Body {
  marbleId: string;
  paymentMethodId?: string;
  setupIntentId: string;
}

export function usePaymentsLss() {
  const mutation = useMutation({
    mutationFn: async (body: Body) =>
      jsonRequest(`${process.env.NEXT_PUBLIC_PAYMENTS_API_URL}/payments/lss`, {
        method: "POST",
        body,
      }),
  });

  return mutation;
}
